/** @jsxImportSource @emotion/react */
"use client";

import { css } from "@emotion/react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

import type { ThemeType } from "../../../../../global/emotion";
import {
  fontSizes,
  fontWeights,
  numericMilliseconds,
  numericPercentages,
  spacing,
} from "../../../../../global/emotion";
import { ChevronDownIcon } from "../../icons/Icon/NavigationIcons";

const triggerStyle = (theme: ThemeType) => ({
  alignItems: "center",
  backgroundColor: theme.semanticColors.background,
  border: "none",
  color: theme.semanticColors.neutralsHighest,
  cursor: "pointer",
  display: "flex",
  fontFamily: theme.fontFamilies.sansSerif,
  fontSize: fontSizes.titleM,
  fontWeight: fontWeights.titleM,
  justifyContent: "space-between",
  paddingBlock: spacing.s,
  width: numericPercentages[100],
  "--transform": "rotate(0deg)",
  ":is([data-state='open'])": {
    "--transform": "rotate(180deg)",
  },
});

const chevronStyle = css({
  transform: "var(--transform)",
  transition: `transform ${numericMilliseconds[200]} ease-out`,
});

export function AccordionTrigger({
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Trigger css={triggerStyle} {...props}>
      {children}
      <ChevronDownIcon css={chevronStyle} />
    </AccordionPrimitive.Trigger>
  );
}
